<app-profile-password-change *ngIf="state === 'profile-password-change'"
                             [displayMode]="'popup'"
                             [application]="application"
                             [isOpened]="isOpened"
                             (close)="onNoClick()" >
</app-profile-password-change>
<app-points-form *ngIf="state === 'profile-points-form'"
                 [application]="application"
                 [profile]="payload.item"
                 (success)="onSuccess()"
                 (close)="onNoClick()">
</app-points-form>
<app-profile-info-popup *ngIf="state === 'profile-info-popup'"
                 [application]="application"
                 [profile]="payload.item.itemFullData"
                 (close)="onNoClick()">
</app-profile-info-popup>
<app-trainer-info-popup *ngIf="state === 'trainer-info-popup'"
                 [application]="application"
                 [profile]="payload.item.itemFullData"
                 (close)="onNoClick()">
</app-trainer-info-popup>
<app-cup-player-info-popup *ngIf="state === 'cup-player-info-popup'"
                 [application]="application"
                 [payload]="payload"
                 (close)="onNoClick()">
</app-cup-player-info-popup>
<app-rename-form *ngIf="state === 'articles-category-rename'"
                 (success)="onSuccess()"
                 (close)="onNoClick()"
                 [application]="application"
                 [payload]="payload"
                 [listItems]="payload.listItems" [state]="state"
>
</app-rename-form>
<app-articles-reorder *ngIf="state === 'articles-reorder' || state === 'articles-category-reorder'"
                      [state]="state"
                      [application]="application"
                      [payload]="payload"
                      [listItems]="payload.listItems"
>
</app-articles-reorder>
<app-share-picker *ngIf="state === 'course-share'"
                  [state]="state"
                  [application]="application"
                  [payload]="payload"
>
</app-share-picker>
<app-delete-confirmation
  *ngIf="['community-class-delete','course-delete','article-delete','articles-category-delete','article-item-delete','event-delete'].indexOf(state) !== -1"
  (success)="onSuccess()"
  (close)="onNoClick()"
  [state]="state"
  [application]="application"
  [payload]="payload">
</app-delete-confirmation>
<app-export-article *ngIf="state === 'article-export'"
                    (success)="onSuccess()"
                    (close)="onNoClick()"
                    [state]="state"
                    [application]="application"
                    [payload]="payload">
</app-export-article>
<app-article-item-editor *ngIf="state === 'article-item-edit'"
                    (success)="onSuccess()"
                    (close)="onNoClick()"
                    [state]="state"
                    [application]="application"
                    [payload]="payload">
</app-article-item-editor>
<app-course-editor *ngIf="state === 'course-edit'"
                    (success)="onSuccess()"
                    (close)="onNoClick()"
                    [state]="state"
                    [application]="application"
                    [payload]="payload">
</app-course-editor>
<app-login-form *ngIf="state === 'popup-login'"
                [application]="application">
</app-login-form>
<app-event-item-view *ngIf="state === 'event-open'"
                         (close)="onNoClick()"
                         [application]="application"
                         [payload]="payload">
</app-event-item-view>
<app-cup-game-popup *ngIf="state === 'cup-game-open'"
                         (success)="onSuccessWithPayload($event)"
                         (close)="onNoClick()"
                         [application]="application"
                         [payload]="payload">
</app-cup-game-popup>
<app-subscribe-event-form *ngIf="state === 'subscribe-event-form'"
                          (success)="onSuccess()"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-subscribe-event-form>
<app-play-config-form *ngIf="state === 'play-config-form'"
                          (success)="onSuccess()"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-play-config-form>
<app-user-details-popup *ngIf="state === 'user-details-popup'"
                          (success)="onSuccess()"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-user-details-popup>
<app-trainer-setup-popup *ngIf="state === 'trainer-setup-popup'"
                          (success)="onSuccess()"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-trainer-setup-popup>
<app-user-referrals-popup *ngIf="state === 'user-referrals-popup'"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-user-referrals-popup>
<app-user-purchases-popup *ngIf="state === 'user-purchases-popup'"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-user-purchases-popup>
<app-service-picker-popup *ngIf="state === 'service-picker'"
                          (success)="onSuccessWithPayload($event)"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-service-picker-popup>
<app-service-config-popup *ngIf="state === 'service-config-popup'"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-service-config-popup>
<app-package-config-popup *ngIf="state === 'package-purchases-popup'"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-package-config-popup>
<app-send-message-popup *ngIf="state === 'message-popup'"
                          (success)="onSuccessWithPayload($event)"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-send-message-popup>
<app-group-create-form *ngIf="state === 'edit-group-form'"
                          (success)="onSuccess()"
                          (close)="onNoClick()"
                          [application]="application"
                          [payload]="payload">
</app-group-create-form>
<app-user-dragger-popup *ngIf="state === 'user-dragger'"
                          [application]="application"
                          [payload]="payload">
</app-user-dragger-popup>
<app-relation-confirmation
  *ngIf="state === 'relation-confirmation'"
  (success)="onSuccess()"
  (close)="onNoClick()"
  [application]="application"
  [payload]="payload">
</app-relation-confirmation>
<app-friend-invitation
  *ngIf="state === 'friend-invitation'"
  (success)="onSuccess()"
  (close)="onNoClick()"
  [application]="application"
  [payload]="payload">
</app-friend-invitation>
<app-game-proposal-component
  *ngIf="state === 'game-proposal'"
  (success)="onSuccess()"
  (close)="onNoClick()"
  [application]="application"
  [payload]="payload">
</app-game-proposal-component>
<app-trainer-calendar-event-form
  *ngIf="state === 'edit-trainer-event'"
  (success)="onSuccess()"
  (close)="onNoClick()"
  [application]="application"
  [payload]="payload">
</app-trainer-calendar-event-form>
<app-schedule-calendar-event-form
  *ngIf="state === 'schedule-calendar-event'"
  (success)="onSuccess()"
  (close)="onNoClick()"
  [application]="application"
  [payload]="payload">
</app-schedule-calendar-event-form>
<app-basic-calendar-event-form
  *ngIf="state === 'basic-calendar-event'"
  (success)="onSuccess()"
  (close)="onNoClick()"
  [application]="application"
  [payload]="payload">
</app-basic-calendar-event-form>
<app-delete-schedule-popup
  *ngIf="state === 'schedule-event-delete'"
  (success)="onSuccessWithPayload($event)"
  (close)="onNoClick()"
  [application]="application"
  [payload]="payload">
</app-delete-schedule-popup>
<app-share-link-popup
  *ngIf="state === 'share-link'"
  (success)="onSuccess()"
  (close)="onNoClick()"
  [application]="application"
  [payload]="payload">
</app-share-link-popup>
<app-user-picker
  *ngIf="state === 'user-pick'"
  (success)="onSuccessWithPayload($event)"
  (close)="onNoClick()"
  [application]="application"
  [payload]="payload">
</app-user-picker>



